import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsClassStepsLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} classStep
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsClassStepsLinkState */

/**
 * @extends {ShapeComponent<ComponentsClassStepsLinkProps, ComponentsClassStepsLinkState>}
 */
class ComponentsClassStepsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    classStep: instanceOfClassName("ClassStep").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, classStep, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--class-steps--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || classStep.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || classStep.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, classStep} = this.p

    if (adminLayout) return Routes.adminClassStepPath(classStep.id())
  }
}

export default memo(shapeComponent(ComponentsClassStepsLink))
